// AMUMIN Beheer (golf 4; DESIGN.md §8.BH): de klantenconsole van de oprichter, "Meekijken door
// AMUMIN" in de instellingen van het gezin, de banner van een gepauzeerd bord en de landingspagina
// van de uitnodiging voor een eigenaar. Toon: je-vorm, korte zinnen, rustig, geen jargon.
export const appBeheerNl = {
    nav: 'Klanten',
    title: 'Beheer',
    subtitle: 'Alleen voor jou als beheerder · alleen gegevens over het account, nooit wat een gezin plant',
    tabs: {
        label: 'Onderdelen van Beheer',
        households: 'Huishoudens',
        accounts: 'Accounthulp',
        audit: 'Wat heeft beheer gedaan',
        /** Korte namen voor een smal scherm (390 px): alle drie passen naast elkaar. */
        short: { households: 'Huishoudens', accounts: 'Accounthulp', audit: 'Logboek' },
    },
    status: {
        networkOk: 'Vertrouwd netwerk',
        networkNo: 'Geen vertrouwd netwerk',
        /** {time} = "21:40". */
        reauthUntil: 'Wijzigen kan tot {time}',
        reauthNeeded: 'Bevestig eerst om iets te wijzigen',
        reauthButton: 'Bevestigen',
    },
    network: {
        title: 'Beheer werkt alleen thuis of op kantoor',
        body: 'Je bent nu op een ander netwerk. Open Beheer vanaf thuis of kantoor; op dit netwerk kun je niets bekijken of wijzigen.',
    },
    reauth: {
        title: 'Bevestig dat jij het bent',
        intro: 'Voor wijzigingen in Beheer vragen we je wachtwoord of een code per e-mail. Daarna kun je {minutes} minuten wijzigen.',
        password: 'Wachtwoord',
        confirm: 'Bevestigen',
        wrong: 'Dit wachtwoord klopt niet.',
        orCode: 'Liever een code per e-mail?',
        sendCode: 'Stuur een code',
        /** {email} = gemaskeerd adres. */
        codeSent: 'We stuurden een code naar {email}.',
        code: 'Code uit de e-mail',
        confirmCode: 'Code bevestigen',
        codeWrong: 'Deze code klopt niet. Kijk nog eens in je e-mail.',
        done: 'Bevestigd. Je kunt nu wijzigen.',
    },
    list: {
        search: 'Zoek op naam of e-mailadres',
        searchButton: 'Zoeken',
        clear: 'Alles tonen',
        new: 'Nieuw huishouden',
        count: { one: '{count} huishouden', other: '{count} huishoudens' },
        emptyTitle: 'Geen huishoudens gevonden',
        emptyBody: 'Zoek op een ander woord, of maak een nieuw huishouden voor een klant.',
        members: { one: '{count} gezinslid', other: '{count} gezinsleden' },
        logins: { one: '{count} login', other: '{count} logins' },
        devices: { one: '{count} tablet', other: '{count} tablets' },
        created: 'Sinds {date}',
        lastActive: 'Laatst actief {date}',
        neverActive: 'Nog niet actief',
        modulesAll: 'Alle modules aan',
        modulesOff: { one: '{count} module uit', other: '{count} modules uit' },
        open: 'Openen',
    },
    state: {
        active: 'Actief',
        invited: 'Uitnodiging open',
        paused: 'Gepauzeerd',
        deletion_scheduled: 'Wordt gewist',
    },
    plans: {
        founder: 'Oprichter',
        free: 'Gratis',
        family: 'Gezin',
        family_plus: 'Gezin plus',
    },
    create: {
        title: 'Nieuw huishouden voor een klant',
        intro: 'De eigenaar krijgt een uitnodiging per e-mail en kiest daar zelf een wachtwoord. Jij ziet dat wachtwoord nooit.',
        name: 'Naam van het huishouden',
        namePlaceholder: 'Familie Jansen',
        email: 'E-mailadres van de eigenaar',
        plan: 'Abonnement',
        submit: 'Aanmaken en uitnodiging sturen',
        /** {email} = gemaskeerd adres. */
        done: 'Aangemaakt. De uitnodiging ging naar {email}.',
    },
    detail: {
        back: 'Alle huishoudens',
        facts: 'Over dit huishouden',
        plan: 'Abonnement',
        created: 'Aangemaakt',
        lastActive: 'Laatst actief',
        people: 'Gezin',
        modules: 'Modules',
        id: 'Nummer',
        actions: 'Wat kun je doen?',
        pause: 'Pauzeren',
        pauseBody: 'Het gezin kan dan alleen kijken. De app en het bord tonen een rustige melding; er gaat niets verloren.',
        pauseReason: 'Waarom? (alleen voor jouw logboek, 24 maanden; geen namen of andere persoonsgegevens)',
        pauseConfirm: 'Ja, pauzeren',
        paused: 'Gepauzeerd sinds {date}. Het gezin kan alleen kijken.',
        resume: 'Weer actief maken',
        resumed: 'Het gezin kan weer alles gebruiken.',
        pausedDone: 'Gepauzeerd. Het gezin kan nu alleen kijken.',
        resendInvite: 'Uitnodiging opnieuw sturen',
        resendDone: 'Nieuwe uitnodiging gestuurd naar {email}. De vorige link werkt niet meer.',
        deletion: 'Wissen plannen',
        deletionBody: 'Het gezin houdt eerst een bedenktijd. Daarna wordt alles gewist. Je kunt het in die tijd nog annuleren.',
        deletionConfirm: 'Ja, wissen plannen',
        deletionCancel: 'Wissen annuleren',
        deletionScheduled: 'Wordt gewist na {date}.',
        /** Review g4 sec r2 (AVG art. 17): de eigenaar vroeg het zelf; Beheer kan het niet tegenhouden. */
        deletionByOwner: 'De eigenaar vroeg dit zelf. Alleen het gezin kan het tegenhouden (in de app: Toch niet verwijderen).',
        deletionByPlatform: 'Gepland door AMUMIN Beheer.',
        deletionOwnerRequested: 'De eigenaar vroeg het verwijderen zelf; alleen het gezin kan het tegenhouden.',
        deletionUnavailable: 'Wissen met bedenktijd komt binnenkort. Er is nu niets gewijzigd.',
    },
    support: {
        title: 'Meekijken',
        none: 'De eigenaar heeft meekijken niet aangezet. Vraag het gezin om het aan te zetten in Instellingen, bij "Meekijken door AMUMIN".',
        /** {date} = "za 26 sep 21:40". */
        allowed: 'De eigenaar laat je meekijken tot {date}. Elke keer dat je kijkt, ziet het gezin.',
        open: 'Meekijken (alleen lezen)',
        heading: 'Zo ziet het bord eruit',
        readOnly: 'Alleen lezen · het gezin ziet dat je meekijkt',
        members: 'Gezin',
        login: 'met login',
        noLogin: 'zonder login',
        rooms: 'Kamers',
        devices: 'Tablets',
        deviceSeen: 'gezien {date}',
        deviceNever: 'nog niet gezien',
        noDevices: 'Nog geen tablet gekoppeld',
        deviceVersion: 'versie {version}',
        outbox: { one: '{count} tik wacht', other: '{count} tikken wachten' },
        week: 'Komende 7 dagen',
        nothing: 'Niets gepland',
        allDay: 'Hele dag',
        everyone: 'Iedereen',
        cancelled: 'afgelast',
        notGranted: 'Meekijken staat niet (meer) aan.',
    },
    accounts: {
        title: 'Accounthulp',
        intro: 'Help een klant die niet kan inloggen. Je ziet nooit een wachtwoord en je kunt er ook geen instellen.',
        email: 'E-mailadres van de klant',
        lookup: 'Opzoeken',
        notFound: 'Geen account met {email}.',
        found: 'Account {email}',
        verified: 'E-mailadres bevestigd',
        notVerified: 'E-mailadres nog niet bevestigd',
        locked: 'Op slot na te veel pogingen',
        lockedUntil: 'Op slot tot {time}',
        notLocked: 'Niet op slot',
        sessions: { one: '{count} actieve sessie', other: '{count} actieve sessies' },
        households: { one: 'In {count} huishouden', other: 'In {count} huishoudens' },
        lastLogin: 'Laatst ingelogd {date}',
        neverLoggedIn: 'Nog nooit ingelogd',
        actions: {
            resend_verification: 'Bevestigingsmail opnieuw sturen',
            unlock: 'Slot eraf halen',
            sign_out_everywhere: 'Overal uitloggen',
        },
        done: {
            resend_verification: 'Nieuwe bevestigingsmail gestuurd.',
            unlock: 'Het slot is eraf. De klant kan weer inloggen.',
            sign_out_everywhere: 'De klant is overal uitgelogd.',
        },
        nothing: {
            resend_verification: 'Dit adres is al bevestigd.',
            unlock: 'Dit account zat niet op slot.',
            sign_out_everywhere: 'Er waren geen actieve sessies.',
        },
    },
    audit: {
        title: 'Wat heeft beheer gedaan',
        intro: 'Alles wat in Beheer gebeurt, staat hier. Niemand kan dit logboek wijzigen.',
        empty: 'Nog niets gedaan in Beheer.',
        actions: {
            'platform.household.create': 'Huishouden aangemaakt',
            'platform.invitation.resend': 'Uitnodiging opnieuw gestuurd',
            'platform.household.pause': 'Gepauzeerd',
            'platform.household.resume': 'Weer actief gemaakt',
            'platform.household.deletion_schedule': 'Wissen gepland',
            'platform.household.deletion_cancel': 'Wissen geannuleerd',
            'platform.support.view': 'Meegekeken',
            'platform.account.lookup': 'Account opgezocht',
            'platform.account.resend_verification': 'Bevestigingsmail opnieuw gestuurd',
            'platform.account.unlock': 'Slot eraf gehaald',
            'platform.account.sign_out_everywhere': 'Overal uitgelogd',
        },
        unknownAction: 'Actie in Beheer',
        gone: 'gewist huishouden',
    },
    settings: {
        title: 'Meekijken door AMUMIN',
        intro: 'Heb je hulp nodig? Dan kan AMUMIN tijdelijk met je meekijken, alleen lezen. Jij bepaalt hoe lang, en elke ouder kan het altijd meteen stoppen.',
        /** Precies wat AMUMIN dan ziet (review g4 sec r1). */
        sees: 'AMUMIN ziet dan: de namen van alle gezinsleden (ook de kinderen), de titels van afspraken van vandaag en de 6 dagen daarna (in een titel kan iets staan als Tandarts; afspraken met een geloofspictogram zoals moskee of kerk niet), de kamers en de tablets. Niet: geloof, gezondheid, school, e-mailadressen of foto’s. Elke keer meekijken zie je hieronder.',
        off: 'Staat uit. Niemand van AMUMIN kan je gezinsbord zien.',
        /** {date} = "za 26 sep 21:40". */
        on: 'AMUMIN mag meekijken tot {date}.',
        howLong: 'Hoe lang?',
        choices: { 1: '1 uur', 24: '1 dag', 72: '3 dagen', 168: '7 dagen' },
        grant: 'Meekijken toestaan',
        granted: 'AMUMIN mag nu meekijken.',
        revoke: 'Nu stoppen',
        revoked: 'Meekijken is gestopt.',
        ownerOnly: 'Alleen de eigenaar van het huishouden kan dit aanzetten.',
        views: 'Wanneer keek AMUMIN mee?',
        /** {date} = "za 26 sep 21:40". */
        viewed: 'AMUMIN Beheer keek mee op {date}',
        noViews: 'AMUMIN heeft nog niet meegekeken.',
    },
    paused: {
        title: 'Je gezinsbord staat even op alleen kijken',
        body: 'Je kunt alles bekijken. Wijzigen kan weer zodra AMUMIN het bord weer aanzet. Vragen? Neem contact op met AMUMIN.',
    },
    invite: {
        title: 'Welkom bij AMUMIN Family Board',
        /** {name} = naam van het huishouden. */
        intro: 'Je bent uitgenodigd als eigenaar van het gezinsbord "{name}".',
        forEmail: 'Deze uitnodiging is voor {email}.',
        yourName: 'Hoe heet je?',
        password: 'Kies een wachtwoord',
        passwordHint: 'Minstens 12 tekens. Alleen jij kent het, ook AMUMIN niet.',
        passwordRepeat: 'Nog een keer je wachtwoord',
        mismatch: 'De twee wachtwoorden zijn niet gelijk.',
        submit: 'Account maken',
        doneTitle: 'Je account is klaar',
        doneBody: 'Log nu in. De eerste keer vragen we ook een code uit je e-mail.',
        login: 'Inloggen',
        existingTitle: 'Je hebt al een account',
        existingBody: 'Log in met {email} en neem de uitnodiging dan aan.',
        accept: 'Uitnodiging aannemen',
        accepted: 'Gelukt. Het gezinsbord is van jou.',
        toBoard: 'Naar het gezinsbord',
        invalidTitle: 'Deze uitnodiging werkt niet meer',
        invalidBody: 'De link is verlopen of al gebruikt. Vraag AMUMIN om een nieuwe uitnodiging.',
        wrongAccount: 'Je bent ingelogd met een ander adres. Log uit en log in met het adres uit de uitnodiging.',
    },
};
//# sourceMappingURL=beheerApp.nl.js.map